/**
 * Q276(사용자 결정 2026-10-13) — 메뉴 › 나 › **동료**: 보디가드와 펫을 한 창에서 본다.
 *
 * 전에는 보디가드가 가방 세 칸 맨 위, 펫은 조련사·상점 › 펫에만 있었다. 둘 다 「나를 따라다니는 것」인데
 * 자리가 갈라져 찾기 어려웠다. 그리기는 원래 모듈의 것을 그대로 부른다 — 서버 값·버튼(act)·저장은 바뀌지 않는다.
 */
import { bodyguardSec } from './inv.js';
import { ownedPetsSec } from './pets.js';
import { GUARD_SHARD_KEY } from '../../world/map.js';
import { muted, num, sec } from './common.js';

export function render(ctx) {
  const guards = bodyguardSec(ctx.y)
    || sec('보디가드', muted('아직 고용한 보디가드가 없다. 경비병의 조각으로 고용할 수 있다.'));
  const b = ctx.y.bodyguard;
  const pet = ctx.y.pet;
  const active = b?.list?.filter((g) => g.active && !g.down).length || 0;
  const down = b?.list?.filter((g) => g.down).length || 0;
  const petActive = pet?.active && !pet?.activeDead;
  const petDown = pet?.owned?.filter((p) => p.dead).length || 0;
  const shards = Number(ctx.j?.[GUARD_SHARD_KEY] ?? ctx.y.inv?.junk?.[GUARD_SHARD_KEY]) || 0;
  const findNew = `<details class="lore" id="companion-recruit"><summary>새 동료 만나기 · 고용과 입양</summary><div class="in">`
    + `<div class="item"><span class="nm">보디가드 고용<span class="qt">경비병의 조각 ${num(shards)}개 보유</span></span>`
    + `<button onclick="act.invView('items');act.pick('j:${GUARD_SHARD_KEY}');act.openPanel('inv')">고용 조건 보기</button></div>`
    + '<div class="item"><span class="nm">새 펫 입양<span class="qt">조련사에게 재주와 가격을 살핀다</span></span><button onclick="act.npc(\'pet\')">조련사 만나기</button></div></div></details>';
  return `<section class="ux-hero"><p class="ux-kicker">함께하는 동료</p><h3 class="ux-title">${active || petActive ? '함께 나갈 준비' : '동료를 불러보자'}</h3>`
    + `<div class="ux-facts"><div class="ux-fact"><span>보디가드</span><b><span class="ux-number">${active}</span><small>명 동행${down ? ' · ' + down + '명 쓰러짐' : ''}</small></b></div>`
    + `<div class="ux-fact"><span>펫</span><b>${petActive ? '동행 중' : '대기 중'}${petDown ? ' · ' + petDown + '마리 쓰러짐' : ''}</b></div></div></section>`
    + guards + ownedPetsSec(ctx) + findNew;
}
